import React from 'react';
import { FaFacebookF, FaInstagram, FaYoutube } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-logo">
          <h2>RCCG David's Court</h2>
          <p>Building a Christ centered community</p>
        </div>

        <div className="footer-socials">
          <h3>Connect with us</h3>
          <div className="social-icons">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
          </div>
        </div>

        <div className="footer-contact">
          <h3>Contact</h3>
          <p>Email: info@rccgdavidscourt.org</p>
          <p>Phone: 0449 939 449</p>
          <p>Address: John McGrath Hall, South Perth, WA</p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} RCCG David's Court. All rights reserved.</p>
        <p>Website by <a href="https://bosgroup.com.au" target="_blank" rel="noopener noreferrer">BOS Group</a></p>
      </div>
    </footer>
  );
};

export default Footer;
